module.exports = __webpack_public_path__ + "images/112_4096.jpg";